module.exports = __webpack_public_path__ + "static/media/search_icon.736db4e3.svg";